import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AttachmentsPanelComponent } from '../components/attachments-panel/attachments-panel.component';
import { FormContactsCustomersComponent } from '../components/contacts-customers-form/contacts-customers-form.component';
import { FormCustomersComponent } from '../components/customers-form/customers-form.component';
import { FormNotesCustomersComponent } from '../components/notes-customers-form/notes-customers-form.component';
import { RankingBarComponent } from '../components/ranking-bar/ranking-bar.component';
import { ActivatedRoute } from '@angular/router';
import { CustomerService } from '../../../services/api/customer.service';
import { CustomersClientCodeComponent } from '../components/customers-client-code/customers-client-code.component';
import { HttpParams } from '@angular/common/http';
import { DocumentsPanelComponent } from '../components/documents-panel/documents-panel.component';
import { CustomersWelcomeLetterComponent } from '../components/customers-welcome-letter/customers-welcome-letter.component';
import { CustomersNdaComponent } from '../components/customers-nda/customers-nda.component';
import { MainLayoutService } from '../../../services/main-layout.service';
import { Subscription } from 'rxjs';
import { AccessControlService } from '../../../services/access-control.service';

@Component({
  selector: 'app-customers-detail-page',
  imports: [FormCustomersComponent,FormContactsCustomersComponent,FormNotesCustomersComponent,RankingBarComponent, CommonModule, CustomersClientCodeComponent, DocumentsPanelComponent, CustomersWelcomeLetterComponent, CustomersNdaComponent],
  templateUrl: './customers-detail-page.component.html',
  styleUrl: './customers-detail-page.component.scss'
})
export class CustomersDetailPageComponent implements OnInit, OnDestroy{
  customer: any;
  customerNotes: any;
  clientPersons:any
  personSentWelcomeLetter:any
  readonly: boolean
  clientsId!: number;
  isRestrictedCustomerProfile = false;
  hideContactsActions = false;
  private subscriptions = new Subscription();

  constructor(
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private mainLayoutService: MainLayoutService,
    private accessControlService: AccessControlService
  ){
    this.readonly = true
  }

  ngOnInit() {
    this.subscriptions.add(
      this.mainLayoutService.activeProfile$.subscribe(profileCode => {
        const isRestricted = !this.accessControlService.hasFeatureActionAccess(profileCode, 'CLIENTS_DETAILS_PANELS', 'modify');
        this.isRestrictedCustomerProfile = isRestricted;
        this.hideContactsActions = isRestricted;
      })
    );
    const clientsId = this.route.snapshot.paramMap.get('clientsId');
    const params = new HttpParams().set('size', '9999');
     this.clientsId = Number(clientsId);
    if (clientsId) {
      this.customerService.detail(this.clientsId).subscribe(response => {
        if (response.status.code === 200) {         
          this.customer = response.data?.customer;
          this.mainLayoutService.setRelatedClientName(this.customer?.companyName || null);
        }
      });
      this.customerService.listClientPersons(this.clientsId).subscribe(response => {
        if (response.status.code === 200) {          
          this.clientPersons = response?.data?.customerPersons;          
        }
      });
      this.customerService.listWelcomeLetters(this.clientsId).subscribe(response => {
        if (response.status.code === 200) {          
          this.personSentWelcomeLetter = response?.data?.customerWelcomeLettersSent;          
        }
      });
      this.customerService.listNotes(this.clientsId, {params}).subscribe(response => {
        if (response.status.code === 200) {  
          this.customerNotes = response?.data?.sectionNotes;          
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.mainLayoutService.setRelatedClientName(null);
  }
  
  onWelcomeLetterSaved(event: any) {
    if (event && event.success) {
      this.customerService.listWelcomeLetters(this.clientsId).subscribe(response => {
        if (response.status.code === 200) {          
          this.personSentWelcomeLetter = response?.data?.customerWelcomeLettersSent;          
        }
      });
    }
  }
}
